import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { interceptNavigation } from "@/lib/nav_guard";
import { navigateTab } from "@/lib/route_transition";
import type { TabDirection } from "@/lib/tabs";
/** Shared navigation guard for tab taps and shell swipes. */
export function useTabNavigation(): (to: string, direction: TabDirection, beforeNavigate?: () => void) => boolean {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return useCallback((to: string, direction: TabDirection, beforeNavigate?: () => void) => {
    if (interceptNavigation(to)) return false;
    navigateTab(to, direction, target => { void navigate(target); }, pathname, beforeNavigate);
    return true;
  }, [navigate, pathname]);
}
